export const en = {
    'cannot-be-empty': 'Fill in the field',
    'default-error': 'Unknown error: {errorCode}',
    'size-cannot-be-more-than-max': 'You can add a total of {total} parameters',
    'this-tracking-system-domain-not-supported': 'This tracking system domain is not supported',
    'this-tracking-system-domain-only-supports-https': 'The tracking system domain only supports the HTTPS protocol',
    'tracker-url-does-not-match-selected-tracker-system':
        "The tracking link domain doesn't belong to the chosen tracking system",
    'tracking-url-doesnt-contain-macros':
        'The tracking link must contain macros for device tracking (logid, google_aid, ios_ifa)'
};
